var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}chbx-circle`,"viewBox":"0 0 14 14"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":_vm.state == 'checked' ? 5 : 6,"fill":"none","stroke":_vm.getColor(_vm.state),"stroke-width":_vm.state == 'checked' ? 4 : 2}})])
}
var staticRenderFns = []

export { render, staticRenderFns }